import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        VRow,
        { staticClass: "justify-center ma-2" },
        [
          _c(
            VCol,
            { attrs: { cols: "12", md: "4" } },
            [
              _c(VSelect, {
                attrs: {
                  "item-text": _vm.getUnidadeSiglaAndNome,
                  items: _vm.unidades,
                  label: "Selecione a unidade",
                  "return-object": "",
                },
                model: {
                  value: _vm.unidade,
                  callback: function ($$v) {
                    _vm.unidade = $$v
                  },
                  expression: "unidade",
                },
              }),
            ],
            1
          ),
          _c(VSpacer, { attrs: { "hidden-sm-and-down": "" } }),
          _c(
            VCol,
            { attrs: { cols: "12", md: "4" } },
            [
              _c(VSelect, {
                attrs: {
                  items: _vm.tiposVisualizacao,
                  "item-text": "name",
                  "item-value": "component",
                  label: "Selecione o tipo de monitoramento",
                },
                model: {
                  value: _vm.currentComponent,
                  callback: function ($$v) {
                    _vm.currentComponent = $$v
                  },
                  expression: "currentComponent",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        { staticClass: "justify-center ma-2" },
        [
          _c(
            "keep-alive",
            [
              _c(_vm.currentComponent, {
                key: _vm.currentComponent + _vm.unidade.sigla,
                tag: "component",
                attrs: { mapeamento: _vm.mapeamento },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }